<template>
    <div v-if="user" class="x mt-4 mx-2">

        <v-row>
            <v-col cols="8">
                <template v-if="user.id == $store.state.user.id">
                    <h3>{{$translate('My account')}}</h3>
                    <p>{{$translate('Here you manage your tasks, payment information, and other things that concern you personally')}}</p> <!--fixme -->
                </template>
            </v-col>

            <v-col cols="4">
                <user-avatar :user="user" border :size="60" change @change="showChangeImageDialog" />
            </v-col>
        </v-row>

        <v-subheader>{{$translate('Personal information')}}</v-subheader>

        <v-form ref="form">
            <form-field v-for="field in fields" :key="field.name" :field="field" v-model="field.value" />
        </v-form>

        <v-btn class="zoezi-button-thin" @click="showPasswordDialog = true" color="primary">{{$translate('Change password')}}</v-btn>

        <set-password v-model="showPasswordDialog" :user="user" />

        <image-upload-dialog v-model="showImageUploadDialog" :user="user" />

        <div class="py-10" />
    </div>
    <div v-else></div>
</template>

<script>
import FormField from '../components/FormField.vue'
import UserAvatar from '../components/UserAvatar.vue'
import SetPassword from '../components/SetPassword.vue'
import ImageUploadDialog from '../components/ImageUploadDialog.vue'
import {debounce} from 'lodash';
export default {
    name: 'zoezi-account',

    zoezi: {
        title: 'Account',
        icon: 'mdi-account-details'
    },

    props: {
        user: {
            type: Object
        },
        debounceEmit: {
            type: Boolean,
            default: true
        }
    },
    
    components: {
        FormField,
        UserAvatar,
        SetPassword,
        ImageUploadDialog
    },

    watch: {
        user: {
            immediate: true,
            handler(user) {
                if (user) {
                    this.setFields();
                }
            }
        },
        '$store.state.settings': {
            immediate: true,
            handler(settings) {
                if (settings) {
                    let more = [
                        {name: 'mailingOptions', title: 'Offer and NewsLetter', type: 'multiselect', data: [{id: 'sms', name: 'SMS'}, {id: 'mail', name: 'E-mail'}]},
                        {name: 'hideforothers', title: 'Hide my information for other members', type: 'checkbox'},
                        //{name: 'allowPush', title: 'Allow push notifications', type: 'checkbox'}
                    ];
                    if (settings.hasLanguage) {
                        more.push({name: 'language', title: 'Language', type: 'language'})
                    }
                    more.forEach(x => {
                        x.builtIn = true;
                        x.changeable_by_member = true;
                    })

                    this.settingsFields = settings.fields.concat(more);
                }
            }
        },
        settingsFields: {
            immediate: true,
            handler(settings) {
                if (settings) {
                    this.setFields();
                }
            }
        },
        fields: {
            deep: true,
            handler() {
                console.log('Something changed...')
                if (this.debounceEmit) {
                    this.debouncedSave();
                } else {
                    this.save();
                }
            }
        }
    },

    data: () => ({
        settingsFields: [],
        fields: [],
        debouncedSave: null,
        showPasswordDialog: false,
        showImageUploadDialog: false
    }),

    methods: {
        setFields() {
            if (!this.user || !this.settingsFields) {
                return [];
            }

            this.fields = (this.settingsFields || []).filter(field => {
                if (field.builtIn) {
                    // FIXME: This is - same as old member page - hardcoded. A better solution would be a setting per field to say if
                    //        member can see the field or not

                    // FIXME: Rename/hide some fields if company

                    const fields = ['firstname', 'lastname', 'homesite_id', 'mail', 'login_key', 'birthdate', 'gender', 'invoiceMail', 'personalCodeNumber', 'phone', 'oldphone', 'address', 'zipCode', 'city', 'mailingOptions', 'position', 'hideforothers', 'allowPush', 'language', 'interest', 'extraInfo'];
                    return fields.includes(field.name) && field.changeable_by_member;
                } else {
                    return field.required || field.changeable_by_member;
                }
            }).map(o => {
                let res = Object.assign({}, o);
                if (!res.builtIn) {
                    res.name = 'xf' + res.name;
                }
                if (res.data && res.data.length) {
                    res.data = res.data.map((o) => {
                        if(typeof(o) === 'string') {return {value: o, text: o};}
                        if (o.id) {
                            return {value: o.id, text: this.$translate(o.name) }
                        }
                        return {value: o.value, text: o.text};
                    });
                }

                res.readonly = !res.changeable_by_member;

                if (res.name == 'personalCodeNumber') {
                    if (!this.user.personalCodeNumber) {
                        res.probePersonalCodeNumber = true;
                    } else {
                        res.readonly = true;
                    }
                }
                
                res.value = this.user[res.name];
                return res;
            });

            return this.fields;
        },
        getChangedFields() {
            if (!this.user) {
                return [];
            }
            return this.fields.filter(x => this.user[x.name] != x.value);
        },
        save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            let cf = this.getChangedFields();
            if (cf.length > 0) {
                let data = {};
                cf.forEach(x => {
                    console.log(x.name + ' was changed');
                    let value = x.value == undefined ? null : x.value;
                    if (x.name.startsWith('xf')) {
                        if (!data.xf) {
                            data.xf = {};
                        }
                        data.xf[x.name.substring(2)] = value;
                    } else {
                        data[x.name] = value;
                    }
                })
                if (this.user.id != this.$store.state.user.id) {
                    data.id = this.user.id;
                }
                this.$api.post('/api/memberapi/change', data)
            } 
        },
        showChangeImageDialog() {
            this.showImageUploadDialog = true;
        }
    },
    mounted() {
        this.debouncedSave = debounce(() => this.save(), 1000);
    },
    beforeDestroy() {
        if (this.debouncedSave) {
            this.debouncedSave.cancel();
        }
        this.save();
    }
}
</script>
